// extracted by mini-css-extract-plugin
export var ComplianceContainer = "index-module--ComplianceContainer--RYR9h";
export var ComplianceContent = "index-module--ComplianceContent--CplTQ";